import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { getTranslation } from '../../../Intl/IntlActions';

const VoucherLineView = ({ voucher, intl }) => {
    return (
        <span>
            {getTranslation(voucher, 'name', intl.locale)} - {voucher.actions.map((action, index) => <span key={action.key}>{`${action.value} ${action.type === 'percentage' ? '%' : '€'} `}</span>)}
        </span>
    );
};

VoucherLineView.propTypes = {
    voucher: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

export default injectIntl(VoucherLineView);
